import state from '@ugc-store';
import { toParse } from './utils';

export interface IProductInfo {
  productId: number;
  displayName: string;
  productImageUrl: string;
  urlName: string;
  partNumber: string;
  brandName: string;
  brandUrl: string;
  brandLogoUrl?: string;
}

export const defaultProduct = {
  productId: 0,
  displayName: '',
  productImageUrl: '',
  urlName: '',
  partNumber: '',
  brandName: '',
  brandUrl: '',
  brandLogoUrl: '',
};

export const initProductId = productId => {
  if (productId !== state.productInfo.productId) {
    state.productInfo = { ...state.productInfo, productId };
  }
};
export const initProductInfo = productInfo => {
  if (productInfo) {
    state.productInfo = toParse(productInfo);
  }
};
